var map = {
	"./20230704_165045.jpg": 20,
	"./IMG-20210902-WA0006.jpg": 31,
	"./WhatsApp Image 2023-10-31 at 02.33.32.jpeg": 642,
	"./WhatsApp Image 2023-10-31 at 02.34.23.jpeg": 627,
	"./WhatsApp Image 2023-10-31 at 02.34.44.jpeg": 896,
	"./WhatsApp Image 2023-10-31 at 02.35.01.jpeg": 222,
	"./WhatsApp Image 2023-10-31 at 02.35.31.jpeg": 497,
	"./WhatsApp Image 2023-10-31 at 02.35.41.jpeg": 42,
	"./WhatsApp Image 2023-10-31 at 02.35.57.jpeg": 325,
	"./WhatsApp Image 2023-10-31 at 02.36.20.jpeg": 352,
	"./WhatsApp Image 2023-10-31 at 02.37.15.jpeg": 605,
	"./WhatsApp Image 2023-10-31 at 02.38.44.jpeg": 612,
	"./WhatsApp Image 2023-11-06 at 01.08.44.jpeg": 8,
	"./WhatsApp Image 2023-11-06 at 01.08.45-2.jpeg": 959,
	"./WhatsApp Image 2023-11-06 at 01.08.45.jpeg": 884,
	"./WhatsApp Image 2023-11-06 at 01.08.46-2.jpeg": 746,
	"./WhatsApp Image 2023-11-06 at 01.08.46.jpeg": 157,
	"./WhatsApp Image 2023-11-06 at 01.08.47-2.jpeg": 901,
	"./WhatsApp Image 2023-11-06 at 01.08.47.jpeg": 398,
	"./WhatsApp Image 2023-11-06 at 01.08.48.jpeg": 663,
	"./WhatsApp Image 2023-11-06 at 01.08.49.jpeg": 416,
	"./WhatsApp Image 2023-11-06 at 01.08.50.jpeg": 206,
	"./WhatsApp Video 2023-10-31 at 02.34.08.mp4": 164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 883;